import { render, staticRenderFns } from "./HomeApoio.vue?vue&type=template&id=0b830374&scoped=true"
import script from "./HomeApoio.vue?vue&type=script&lang=js"
export * from "./HomeApoio.vue?vue&type=script&lang=js"
import style0 from "./HomeApoio.vue?vue&type=style&index=0&id=0b830374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b830374",
  null
  
)

export default component.exports